import { db } from '../db';
import type { ScoreRecord } from '../types';
import { scoreSession } from '@/domain/scoring';
import { getTrials, toScoredTrials } from './sessions';

export const SCORING_VERSION = '1.1.0';

/** Recompute only known legacy scores from complete raw records; preserve prior derivatives. */
export async function upgradeLegacyScores(): Promise<void> {
  await db.transaction('rw', db.scores, db.trials, db.sessions, async () => {
    const legacy = await db.scores.filter(r => r.scoringVersion === '1.0.0').toArray();
    for (const record of legacy) {
      const session = await db.sessions.get(record.sessionId);
      const trials = await getTrials(record.sessionId);
      if (!session?.endedAt || session.abortedReason || trials.length !== session.trialCount || !trials.length) continue;
      await db.scores.put({
        ...record,
        previousScoring: { scoringVersion: record.scoringVersion, computedAt: record.computedAt, scores: record.scores },
        scores: scoreSession(toScoredTrials(trials)), scoringVersion: SCORING_VERSION, computedAt: new Date().toISOString(),
      });
    }
  });
}

export async function saveScores(rec: ScoreRecord): Promise<void> {
  await db.scores.put(rec);
}
export const getScoresForSession = (sessionId: string) => db.scores.where('sessionId').equals(sessionId).first();
export const listScores = (limit = 200) => db.scores.orderBy('computedAt').reverse().limit(limit).toArray();
export const listScoresFor = (participantId: string) =>
  db.scores.where('[participantId+computedAt]').between([participantId, ''], [participantId, '￿']).toArray();
